import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './indicator.module.css';

type Props = {
  readonly length: number;
  readonly currentIndex: number;
  readonly slideOnClickDot: (index: number) => void;
};

export function Indicator({currentIndex, length, slideOnClickDot}: Props) {
  if (length === 1) return null;

  return (
    <div
      className={clsx(
        styles.indicator,
        isContainerQueryAvailable()
          ? styles.indicatorCQ
          : styles.indicatorFallback,
      )}
    >
      {Array.from({length}, (_, index) => index).map((index) => (
        <button
          key={index + 1}
          type='button'
          className={clsx(
            styles.dot,
            index + 1 === currentIndex && styles.dotActive,
          )}
          aria-label={`${index + 1}ページ目に移動`}
          onClick={() => {
            slideOnClickDot(index + 1);
          }}
        />
      ))}
    </div>
  );
}
